import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import MailFolderTableQuery from '../store/schema/MailFolderTableQuery';
import mailStore from 'owa-mail-store/lib/store/Store';
import TableView from '../store/schema/TableView';
import { TableQueryType } from '../store/schema/TableQuery';

/**
 * Gets the focused view filter for the given table
 * @returns the focused view filter
 */

export default function getFocusedFilterForTable(tableView: TableView): FocusedViewFilter {
    tableView = tableView ?? getSelectedTableView(); //If the tableView is not present, try to get it from store
    if (tableView.tableQuery) {
        switch (tableView.tableQuery.type) {
            case TableQueryType.Folder:
                return (tableView.tableQuery as MailFolderTableQuery).focusedViewFilter;
            case TableQueryType.Search:
                return FocusedViewFilter.None;
            default:
                throw new Error(
                    'Table Query should be either of type search, mail folder or group'
                );
        }
    } else {
        //If both tableView and store are empty, look at the user configuration as a fallback
        if (getUserConfiguration()?.UserOptions?.IsFocusedInboxEnabled) {
            return mailStore?.folders?.selectedFocusedViewFilter === 1
                ? FocusedViewFilter.Other
                : FocusedViewFilter.Focused;
        }
        /*Keep this line devoid of any conditions, so that in the worst case in which all values that can be used to determine whether the focused view is enabled are null, we return None*/
        return FocusedViewFilter.None;
    }
}
